export enum Sex {
  Male = "muž",
  Female = "žena",
  Undefined = "",
}
